// Imports
import React, { Component } from 'react';
import { compose } from 'recompose';
import moment from 'moment';
import $ from 'jquery';
import Badwords from 'bad-words';

import BrowseNavigation from './partials/BrowseNavigation';
import Preloader from './partials/Preloader';
import Modal from './partials/Modal';
import TheEnd from './partials/TheEnd';

import { withFirebase } from './config';
import { AuthUserContext } from './session';

class Landing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      poems: [], // Array of poems
      limit: 10, // Limit of poems for query
      loading: true,
      loadingMore: false,
      timeFrame: 'today', // Sort by highest daily ink
      isInking: false, // No poem is currently being given ink
      filter: 'all'
    };

    // Bind time filter function to this
    this.onSetTimeFrame = this.onSetTimeFrame.bind(this);
    this.onSetFilter = this.onSetFilter.bind(this);
  }
  componentDidMount() {
    document.title = 'Splotching poems' + ' - Poetryphile';
    // Fetch splotching poems from db
    let loadingMore = false;
    this.onListenForSplotchingPoems(loadingMore);
  }
  componentDidUpdate() {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('#scroll').fadeIn();
      } else {
        $('#scroll').fadeOut();
      }
    });
    $('#scroll').click(function () {
      $('html, body').animate({ scrollTop: 0 }, 600);
      return false;
    });
  }
  onListenForSplotchingPoems = loadingMore => {
    let splotchingPoems;
    if (this.state.filter == 'all') {
      // Query all poems
      if (this.state.timeFrame == 'today') {
        splotchingPoems = this.props.firebase
          .poems()
          .where('type', '==', 'public') // public poems only
          .orderBy('dailyInk', 'desc') // fetch by greatest daily ink
          .limit(this.state.limit); // limit
      } else if (this.state.timeFrame == 'week') {
        splotchingPoems = this.props.firebase
          .poems()
          .where('type', '==', 'public') // public poems only
          .orderBy('weeklyInk', 'desc') // fetch by greatest weekly ink
          .limit(this.state.limit); // limit
      } else if (this.state.timeFrame == 'month') {
        splotchingPoems = this.props.firebase
          .poems()
          .where('type', '==', 'public') // public poems only
          .orderBy('monthlyInk', 'desc') // fetch by greatest monthly ink
          .limit(this.state.limit); // limit
      }
    } else if (this.state.filter == 'classics') {
      // Classics only
      if (this.state.timeFrame == 'today') {
        splotchingPoems = this.props.firebase
          .poems()
          .where('type', '==', 'public') // public poems only
          .where('isClassic', '==', true) // Classics only
          .orderBy('dailyInk', 'desc') // fetch by greatest daily ink
          .limit(this.state.limit); // limit
      } else if (this.state.timeFrame == 'week') {
        splotchingPoems = this.props.firebase
          .poems()
          .where('type', '==', 'public') // public poems only
          .where('isClassic', '==', true) // Classics only
          .orderBy('weeklyInk', 'desc') // fetch by greatest weekly ink
          .limit(this.state.limit); // limit
      } else if (this.state.timeFrame == 'month') {
        splotchingPoems = this.props.firebase
          .poems()
          .where('type', '==', 'public') // public poems only
          .where('isClassic', '==', true) // Classics only
          .orderBy('monthlyInk', 'desc') // fetch by greatest monthly ink
          .limit(this.state.limit); // limit
      }
    } else if (this.state.filter == 'original') {
      // Original content only
      if (this.state.timeFrame == 'today') {
        splotchingPoems = this.props.firebase
          .poems()
          .where('type', '==', 'public') // public poems only
          .where('isClassic', '==', false) // Original content only
          .orderBy('dailyInk', 'desc') // fetch by greatest daily ink
          .limit(this.state.limit); // limit
      } else if (this.state.timeFrame == 'week') {
        splotchingPoems = this.props.firebase
          .poems()
          .where('type', '==', 'public') // public poems only
          .where('isClassic', '==', false) // Original content only
          .orderBy('weeklyInk', 'desc') // fetch by greatest weekly ink
          .limit(this.state.limit); // limit
      } else if (this.state.timeFrame == 'month') {
        splotchingPoems = this.props.firebase
          .poems()
          .where('type', '==', 'public') // public poems only
          .where('isClassic', '==', false) // Original content only
          .orderBy('monthlyInk', 'desc') // fetch by greatest monthly ink
          .limit(this.state.limit); // limit
      }
    }

    loadingMore == false
      ? splotchingPoems
          .get()
          .then(snapshot => {
            snapshot.size
              ? this.onGetSplotchingPoems(snapshot, loadingMore)
              : this.setState({ poems: null, loading: false });
          })
          .then(() => {
            console.log('Fetched splotching poems');
          })
          .catch(err => {
            console.log('Error fetching splotching poems' + err);
            this.setState({ poems: null, loading: false });
          })
      : splotchingPoems
          .get()
          .then(snapshot => {
            snapshot.size
              ? this.onGetSplotchingPoems(snapshot, loadingMore)
              : this.setState({ loadingMore: false });
          })
          .then(() => {
            console.log('Fetched more splotching poems');
          })
          .catch(err => {
            console.log('Error fetching more splotching poems ' + err);
            this.setState({ loadingMore: false });
          });
  };
  async onGetSplotchingPoems(snapshot, loadingMore) {
    try {
      if (this.props.firebase.auth.currentUser != null) {
        var currentUser = await this.props.firebase
          .user(this.props.firebase.auth.currentUser.uid)
          .get();
      }
      let poems = [];
      // Loop through poems in snapshot
      for (let i in snapshot.docs) {
        // Get poem data
        let poem = snapshot.docs[i].data();
        // Get poem poet
        let poet = await this.props.firebase.user(poem.poetId).get();

        if (this.props.firebase.auth.currentUser != null) {
          if (currentUser.data().hideExplicit == true) {
            var filter = new Badwords();
            poem.text = filter.clean(poem.text);
          }
        }
        // Add poem to poems array
        if (poem.inkers.length < 1) {
          // Poem has no inkers
          await poems.push({
            ...poem,
            poet: poet.data(),
            inkers: [],
            uid: snapshot.docs[i].id
          });
        } else {
          let inkers = [];
          // Loop through poem inkers
          for (let i in poem.inkers) {
            // Poem has inkers
            const inkerId = await poem.inkers[i];
            // Get inker data
            let inker = await this.props.firebase.user(inkerId).get();
            // Add inker to inkers array
            await inkers.push({
              inker: inker.data(),
              uid: inkerId
            });
          }
          // Add poem to poems array
          await poems.push({
            ...poem,
            poet: poet.data(),
            inkers: inkers,
            uid: snapshot.docs[i].id
          });
        }
      }
      // Set poems in state when finished adding them to array
      await this.setState({
        poems
      });
      // Query total number of poems
      await this.props.firebase
        .poems()
        .doc('collectionInfo')
        .get()
        .then(snapshot => {
          switch (loadingMore) {
            case true:
              if (this.state.filter == 'all') {
                this.setState({
                  totalPoems: snapshot.data().totalPublic, // Set total poem count to state
                  loadingMore: false
                });
                break;
              } else if (this.state.filter == 'classics') {
                this.setState({
                  totalPoems: snapshot.data().classics, // Set total poem count to state
                  loadingMore: false
                });
                break;
              } else if (this.state.filter == 'original') {
                this.setState({
                  totalPoems: snapshot.data().total - snapshot.data().classics, // Set total poem count to state
                  loadingMore: false
                });
                break;
              }
            case false:
              if (this.state.filter == 'all') {
                this.setState({
                  totalPoems: snapshot.data().totalPublic, // Set total poem count to state
                  loading: false
                });
                break;
              } else if (this.state.filter == 'classics') {
                this.setState({
                  totalPoems: snapshot.data().classics, // Set total poem count to state
                  loading: false
                });
                break;
              } else if (this.state.filter == 'original') {
                this.setState({
                  totalPoems: snapshot.data().total - snapshot.data().classics, // Set total poem count to state
                  loading: false
                });
                break;
              }
          }
        });
    } catch (err) {
      console.log(err);
      console.log('Error fetching splotching poems');
      switch (loadingMore) {
        case true:
          this.setState({ loadingMore: false });
          break;
        case false:
          this.setState({ poems: null, loading: false });
          break;
      }
    }
  }
  async switchTimeFrame() {
    try {
      let loadingMore = false;
      this.onListenForSplotchingPoems(loadingMore);
    } catch (err) {
      console.log('Error switching time frame');
      this.setState({ poems: null, loading: false });
    }
  }
  async switchFilter() {
    try {
      console.log('Switching filter...');
      let loadingMore = false;
      this.onListenForSplotchingPoems(loadingMore);
    } catch (err) {
      console.log('Error switching filter');
      this.setState({ poems: null, loading: false });
    }
  }
  onSetTimeFrame(event, frame) {
    event.preventDefault();
    this.setState(
      { timeFrame: frame, limit: 10, loading: true }, // Time frame today, reset limit
      this.switchTimeFrame
    );
  }
  onSetFilter(event, filter) {
    event.preventDefault();
    this.setState(
      { filter: filter, limit: 10, loading: true }, // Time frame today, reset limit
      this.switchFilter
    );
  }
  loadMorePoems = () => {
    this.setState(
      state => ({ limit: state.limit + 5, loadingMore: true }), // Add 5 to query limit
      this.addSplotchingPoems
    );
  };
  addSplotchingPoems = async () => {
    try {
      let loadingMore = true;
      this.onListenForSplotchingPoems(loadingMore);
    } catch (err) {
      this.setState({ loadingMore: false });
    }
  };
  async updatePoem(poem) {
    try {
      let poemDoc = await this.props.firebase.poem(poem.uid).get(); // Query poem clicked on

      let newInkers = await poemDoc.data().inkers.slice(); // Make copy of current inkers

      if (
        poemDoc
          .data()
          .inkers.includes(this.props.firebase.auth.currentUser.uid) == false // Only increment ink if inker has not already inked
      ) {
        newInkers.push(this.props.firebase.auth.currentUser.uid); // Add new inker to inkers array
        await this.props.firebase.poem(poem.uid).update({
          inkers: newInkers,
          ink: this.props.firebase.fieldValue.increment(1)
        });
      }
    } catch (err) {
      console.log('Error inking');
      this.setState({ isInking: false });
    }
  }

  async addInk(poem) {
    try {
      let author = await poem.poetRef.get();
      await this.props.firebase.inks().add({
        // Add ink document to represent given ink
        inkerRef: this.props.firebase.db
          .collection('users')
          .doc(this.props.firebase.auth.currentUser.uid), // Reference to inker
        poemRef: this.props.firebase.db.collection('poems').doc(poem.uid), // Reference to poem
        createdAt: this.props.firebase.fieldValue.serverTimestamp(), // Ink action timestamp
        inkerId: this.props.firebase.auth.currentUser.uid, // id of inker
        poemId: poem.uid, // id of poem
        authorId: author.id // id of author
      });
    } catch (err) {
      this.setState({ isInking: false });

      // If error, remove inker id from inkers array that was added in updatePoem function
      let poemDoc = await this.props.firebase.poem(poem.uid).get(); // Query peom being given ink

      let newInkers = await poemDoc.data().inkers.slice(); // Get copy of inkers
      if (
        poemDoc
          .data()
          .inkers.includes(this.props.firebase.auth.currentUser.uid) == true // If inkerId was successfully added to inker array
      ) {
        let filteredInkers = newInkers.filter(
          id => id !== this.props.firebase.auth.currentUser.uid // remove it
        );
        await this.props.firebase.poem(poem.uid).update({
          inkers: filteredInkers,
          ink: this.props.firebase.fieldValue.increment(-1)
        });
      }

      this.setState({ isInking: false });
    }

    try {
      let author = await poem.poetRef.get(); // Query author of poem being given ink
      await this.props.firebase.user(author.id).update({
        ink: this.props.firebase.fieldValue.increment(1) // Increment their ink
      });
      this.setState({ isInking: false });
    } catch (err) {
      // If error, remove inker id from inkers array that was added in updatePoem function

      this.setState({ isInking: false });

      let poemDoc = await this.props.firebase.poem(poem.uid).get(); // Query poem being given ink

      let newInkers = await poemDoc.data().inkers.slice(); // Get copy of inkers
      if (
        poemDoc
          .data()
          .inkers.includes(this.props.firebase.auth.currentUser.uid) == true // If inkerId was successfully added to inker array
      ) {
        let filteredInkers = newInkers.filter(
          id => id !== this.props.firebase.auth.currentUser.uid // Filter inkerId out of inker array
        );
        await this.props.firebase.poem(poem.uid).update({
          inkers: filteredInkers,
          ink: this.props.firebase.fieldValue.increment(-1) // Decrement the ink of the poem because ink action failed
        });
      }
      await this.props.firebase
        .inks()
        .where('inkerId', '==', this.props.firebase.auth.currentUser.uid)
        .where('poemId', '==', poem.uid)
        .onSnapshot(async snapshot => {
          if (snapshot.size) {
            for (var i in snapshot.docs) {
              const doc = snapshot.docs[i];
              await doc.ref.delete(); // Delete the ink document that was created because ink action failed
            }
          }
        });
    }
  }

  onInk = async (event, poem) => {
    try {
      event.preventDefault();

      this.setState({ isInking: true });

      await this.updatePoem(poem);

      await this.addInk(poem);

      this.setState({ isInking: false });

      let loadingMore = false;

      this.onListenForSplotchingPoems(loadingMore);
    } catch (err) {
      console.log('Error inking ' + err);
      this.setState({ isInking: false });
    } finally {
      console.log('Finished giving ink');
    }
  };
  render() {
    const {
      loading,
      poems,
      limit,
      loadingMore,
      totalPoems,
      timeFrame,
      isInking
    } = this.state;
    return (
      <div>
        <AuthUserContext.Consumer>
          {authUser => (
            <div>
              {loading == true ? (
                <Preloader />
              ) : (
                <div style={{ position: 'relative' }}>
                  <BrowseNavigation />
                  <Modal
                    filterPoemsModal={true}
                    filter={this.state.filter}
                    onSetFilter={(event, filter) =>
                      this.onSetFilter(event, filter)
                    }
                  />
                  <ul
                    id='toolbar'
                    style={{ marginTop: '50px', overflow: 'visible' }}
                    className='collection container'>
                    <div>
                      <span className='right' style={{ marginBottom: '10px' }}>
                        <a
                          style={{
                            background: '#da694b',
                            borderRadius: '18px'
                          }}
                          className='waves-effect z-depth-0 btn modal-trigger'
                          data-target='modal-filter'>
                          <i
                            style={{ color: 'white' }}
                            className='material-icons left'>
                            tune
                          </i>
                          filter
                        </a>
                      </span>
                    </div>
                  </ul>
                  <div
                    id='scroll'
                    style={{ top: '100px' }}
                    className='fixed-action-btn horizontal'>
                    <a
                      style={{ backgroundColor: '#da694b' }}
                      className='btn-floating btn-small'>
                      <i className='large material-icons'>arrow_drop_up</i>
                    </a>
                  </div>
                  <br />
                  <br />
                  <br />
                  <ul
                    style={{ marginTop: '-10px' }}
                    id='poems'
                    className='collection with-header container'>
                    <li
                      style={{ height: '125px' }}
                      id='splotching-header'
                      className='collection-header'>
                      <p
                        style={{ marginTop: '13px', marginBottom: '7px' }}
                        id='my-poems'
                        className='plotching-phrase'>
                        Splotching Poems
                      </p>
                      <div>
                        <a
                          href='#!'
                          onClick={event => this.onSetTimeFrame(event, 'today')}
                          style={{ color: '#413043' }}
                          className={[
                            timeFrame == 'today' && 'time-filter',
                            'time-filter-option'
                          ]
                            .filter(e => e)
                            .join(' ')}>
                          Today
                        </a>
                        &nbsp;&nbsp;
                        <a
                          href='#!'
                          onClick={event => this.onSetTimeFrame(event, 'week')}
                          style={{ color: '#413043' }}
                          className={[
                            timeFrame == 'week' && 'time-filter',
                            'time-filter-option'
                          ]
                            .filter(e => e)
                            .join(' ')}>
                          Week
                        </a>
                        &nbsp;&nbsp;
                        <a
                          href='#!'
                          onClick={event => this.onSetTimeFrame(event, 'month')}
                          style={{ color: '#413043' }}
                          className={[
                            timeFrame == 'month' && 'time-filter',
                            'time-filter-option'
                          ]
                            .filter(e => e)
                            .join(' ')}>
                          Month
                        </a>
                      </div>
                    </li>
                    <div>
                      {totalPoems < 1 || poems == null ? (
                        <li id='no-public' className='collection-item'>
                          <center>
                            <svg
                              style={{ width: '200px', marginTop: '-5px' }}
                              id='Layer_1'
                              data-name='Layer 1'
                              xmlns='http://www.w3.org/2000/svg'
                              viewBox='0 0 2000 2000'>
                              <title>Poetryphile No Poems</title>
                              <path
                                d='M1593.53,554.29h95.88a59.42,59.42,0,0,0,59.43-59.42h0a59.42,59.42,0,0,0-59.43-59.42h-95.88Z'
                                style={{ fill: '#da694b' }}
                              />
                              <path
                                d='M1367.81,1564.56h81.42a59.43,59.43,0,0,0,59.43-59.43h0a59.43,59.43,0,0,0-59.43-59.43h-81.42Z'
                                style={{ fill: '#da694b' }}
                              />
                              <path
                                d='M637.4,554.29v97.8a237.09,237.09,0,0,0,178.27,80.49h534.85V673.14H815.67a178.33,178.33,0,0,1-168.1-118.85Z'
                                style={{ fill: '#fff' }}
                              />
                              <path
                                d='M1640.15,435.43C1613.77,332.9,1520.7,257.16,1410,257.16H815.67c-1.91,0-3.81,0-5.71.07l-1.8.06c-1.3,0-2.6.09-3.89.15l-2.12.11c-1.2.07-2.39.14-3.58.23l-2.17.16c-1.2.09-2.41.2-3.6.32l-2,.19c-1.39.15-2.78.31-4.16.48l-1.4.17c-1.82.23-3.62.48-5.43.75l-1.77.29c-1.23.2-2.45.39-3.67.61l-2.24.41-3.18.61-2.36.48-3.06.67-2.35.53-3.13.77c-.73.18-1.46.35-2.19.54-1.5.39-3,.8-4.49,1.22l-2.55.74c-1,.3-2.1.61-3.13.93-.84.25-1.66.52-2.49.79l-2.64.85-2.58.88-2.49.88-2.61.95-2.39.91-2.64,1-2.26.92q-2.65,1.09-5.28,2.25l-1.85.8-2.81,1.3c-.67.31-1.33.61-2,.93-.94.44-1.87.9-2.8,1.35l-1.92,1c-.94.47-1.87.95-2.8,1.43l-1.82,1c-.95.51-1.91,1-2.85,1.54-.51.27-1,.56-1.52.84q-5.26,2.94-10.35,6.14l-1.13.7q-1.49.94-3,1.92l-1.38.91-2.88,1.95-1.36.95c-1,.67-1.94,1.36-2.91,2.05l-1.1.8q-7.07,5.14-13.72,10.79l-.88.74q-1.44,1.23-2.85,2.49l-1,.87-2.81,2.55-.85.79c-1,.91-2,1.83-2.92,2.76l-.16.15q-5,4.82-9.69,9.92l-.33.35c-.93,1-1.84,2-2.74,3-.23.26-.46.51-.68.77-.88,1-1.75,2-2.61,3l-.66.78c-.88,1-1.76,2.1-2.63,3.16l-.29.37q-5.82,7.15-11.07,14.77l-.39.56c-.79,1.14-1.56,2.3-2.33,3.46l-.48.73c-.77,1.18-1.53,2.36-2.28,3.55-.11.16-.21.32-.31.48q-5,8-9.38,16.35l-.07.15c-.69,1.31-1.36,2.63-2,4-.09.2-.19.4-.29.6-.65,1.3-1.28,2.61-1.9,3.93l-.23.5a233.79,233.79,0,0,0-9,22.14c0,.1-.07.19-.1.28-.51,1.45-1,2.92-1.48,4.38l-.12.39q-3.37,10.38-5.8,21.15a.94.94,0,0,0,0,.16c-.49,2.18-.94,4.38-1.37,6.58-.08.38-.15.77-.22,1.15q-.57,3-1.06,6c-.06.34-.12.68-.17,1q-1.11,7-1.8,14.14c-.05.46-.08.93-.13,1.39q-.26,2.82-.45,5.66c0,.61-.07,1.21-.11,1.82-.11,1.88-.2,3.78-.27,5.67l-.06,1.46q-.11,3.6-.11,7.23v772.55c-110.74,0-203.82,75.78-230.21,178.29a239.75,239.75,0,0,0,0,118.84c26.39,102.53,119.47,178.29,230.21,178.29h594.29c110.74,0,203.82-75.76,230.21-178.29a238.06,238.06,0,0,0,7.49-59.42V732.58c110.75,0,203.83-75.78,230.22-178.29a239.21,239.21,0,0,0,0-118.86ZM817.54,673.14h-1.87a177.36,177.36,0,1,1,1.87,0Zm-417.85,832c0-98.44,79.83-178.27,178.27-178.27v356.56C479.52,1683.42,399.69,1603.59,399.69,1505.13Zm950.83,0c0,98.46-79.83,178.29-178.27,178.29H637.4V652.11a239,239,0,0,0,62.18,50.23l.06,0c1.76,1,3.53,2,5.32,2.89l.2.11c1.76.92,3.54,1.83,5.32,2.71l.23.11q2.71,1.34,5.47,2.61l.1.05a236.25,236.25,0,0,0,35.3,13l.28.07q2.82.8,5.66,1.5l.93.23c1.69.42,3.38.82,5.09,1.2l.45.11.83.17c1.59.35,3.19.68,4.8,1l1.5.28c1.54.3,3.09.57,4.65.84l1.62.27c1.54.25,3.08.48,4.62.7l1.66.23c1.56.21,3.12.4,4.69.58l1.6.18c1.63.18,3.27.33,4.9.47l1.42.13c1.78.14,3.57.26,5.36.37l1,.06c4.31.23,8.66.36,13,.36h534.85Zm59.43-832h-437a237.67,237.67,0,0,0,0-356.56H1410a178.3,178.3,0,0,1,178.29,178.29C1588.24,593.31,1508.41,673.14,1410,673.14Z'
                                style={{ fill: '#413043' }}
                              />
                              <rect
                                x='671.4'
                                y='435.44'
                                width='178.28'
                                height='118.86'
                                rx='59.43'
                                ry='59.43'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='292.02'
                                y='1445.7'
                                width='218.24'
                                height='118.86'
                                rx='59.43'
                                ry='59.43'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='850.25'
                                width='476.27'
                                height='59.53'
                                transform='translate(1987.93 1760.04) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='969.32'
                                width='476.27'
                                height='59.53'
                                transform='translate(1987.93 1998.18) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='1088.39'
                                width='476.27'
                                height='59.53'
                                transform='translate(1987.93 2236.32) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='1207.46'
                                width='476.27'
                                height='59.53'
                                transform='translate(1987.93 2474.45) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='1326.53'
                                width='476.27'
                                height='59.53'
                                transform='translate(1987.93 2712.59) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                              <rect
                                x='755.83'
                                y='1445.6'
                                width='357.21'
                                height='59.53'
                                transform='translate(1868.86 2950.73) rotate(180)'
                                style={{ fill: '#da694b' }}
                              />
                            </svg>
                            <h4 id='no-public-poems' className='futura'>
                              There are no Splotching Poems!
                            </h4>
                          </center>
                        </li>
                      ) : (
                        <PoemList
                          poems={poems}
                          limit={limit}
                          loadMorePoems={this.loadMorePoems}
                          loadingMore={loadingMore}
                          totalPoems={totalPoems}
                          authUser={authUser}
                          onInk={this.onInk}
                          isInking={isInking}
                        />
                      )}
                    </div>
                  </ul>
                  <br />
                </div>
              )}
            </div>
          )}
        </AuthUserContext.Consumer>
      </div>
    );
  }
}

const PoemList = ({
  poems,
  limit,
  loadMorePoems,
  loadingMore,
  totalPoems,
  authUser,
  onInk,
  isInking
}) => (
  <ul>
    {poems &&
      poems.map(poem => (
        <li key={poem.uid} className='collection-item'>
          <Modal poem={poem} inkerModal={true} />
          <div
            className={[
              poem.format == 'format_align_left' && 'format-left',
              poem.format == 'format_align_center' && 'format-center',
              poem.format == 'format_align_right' && 'format-right'
            ]
              .filter(e => e)
              .join(' ')}>
            <div style={{ fontSize: '17px', paddingTop: '20px' }}>
              By 
              <a
                href={`/poets/@${poem.poet.penName}`}
                className='poet-browse-name'>
                {poem.poet.penName}
                <span style={{ fontWeight: 'bold' }}>
                  <div className='ink-line ink-score'>
                    <span
                      style={{
                        color: '#da694b',
                        display: 'inline-block',
                        paddingRight: '3px',
                        paddingLeft: '5px'
                      }}>
                      (
                    </span>
                    <span
                      style={{
                        display: 'inline-block',
                        color: '#413043',
                        fontSize: '17px'
                      }}>
                      {poem.poet.ink}
                      <svg
                        style={{
                          width: '50px',
                          marginLeft: '-15px',
                          position: 'absolute',
                          zIndex: 0
                        }}
                        id='Layer_1'
                        data-name='Layer 1'
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 2000 2000'>
                        <title>Ink</title>
                        <path d='M1285.91,1054.23a285.13,285.13,0,0,1-90.46,208.66c-109.23,102.48-281.67,102.48-390.9,0a285.89,285.89,0,0,1-6.71-410.83l184.5-184.49a25,25,0,0,1,35.32,0l184.5,184.49A285.07,285.07,0,0,1,1285.91,1054.23Z' />
                      </svg>
                    </span>
                    <span
                      style={{
                        color: '#da694b',
                        display: 'inline-block',
                        paddingLeft: '20px'
                      }}>
                      )
                    </span>
                  </div>
                </span>
              </a>
              <br />
              {poem.isClassic == false ? (
                <p
                  className={[
                    'created-at',
                    poem.format == 'format_align_center' && 'created-at-center'
                  ]
                    .filter(e => e)
                    .join(' ')}>
                  {moment(poem.datePublic.toDate()).fromNow()}
                </p>
              ) : (
                <p
                  className={[
                    'created-at',
                    poem.format == 'format_align_center' && 'created-at-center'
                  ]
                    .filter(e => e)
                    .join(' ')}>
                  {poem.classicDate}
                </p>
              )}
            </div>
            {poem.title.replace(/\s/g, '') == '' && (
              <a
                href={`/poems/${poem.uid}/edit`}
                className='poem-title-new futura'>
                Untitled Poem
              </a>
            )}
            <a
              style={{ overflowWrap: 'break-word', whiteSpace: 'pre-wrap' }}
              href={`/poems/${poem.uid}`}
              className='poem-title-new'>
              {poem.title}
            </a>
            <br />
            <div
              className='poem-text'
              id={poem.uid}
              style={{
                marginTop: '5px',
                overflowWrap: 'break-word',
                whiteSpace: 'pre-wrap'
              }}>
              {poem.text.substring(0, 150)}
            </div>
            {poem.text.length > 150 && (
              <div style={{ paddingTop: '5px' }}>
                <a
                  href='#!'
                  id={`${poem.uid}read-more`}
                  onClick={() => {
                    $(`#${poem.uid}`).html(poem.text);
                    $(`#${poem.uid}read-more`).css('display', 'none');
                  }}
                  className='read-more'>
                  Read More
                </a>
              </div>
            )}
            <div>
              <a
                href='#!'
                data-target={`${poem.uid}modal-inkers`}
                style={{ fontSize: '17px', marginLeft: '40px' }}
                className={[
                  poem.format == 'format_align_center' && 'format-center-num',
                  poem.format == 'format_align_left' && 'format-left-num',
                  poem.format == 'format_align_right' && 'format-right-num',
                  'modal-trigger',
                  authUser != undefined &&
                    poem.inkers.some(e => e.uid == authUser.uid) &&
                    'orange-ink-count'
                ]
                  .filter(e => e)
                  .join(' ')}>
                {poem.ink} ink
              </a>
              {authUser != null ? (
                <div>
                  {poem.inkers.some(e => e.uid == authUser.uid) ? (
                    <svg
                      className={[
                        poem.format == 'format_align_center' &&
                          'format-center-ink',
                        poem.format == 'format_align_left' && 'format-left-ink',
                        poem.format == 'format_align_right' &&
                          'format-right-ink',
                        'ink-upvoted'
                      ]
                        .filter(e => e)
                        .join(' ')}
                      id='Layer_1'
                      data-name='Layer 1'
                      xmlns='http://www.w3.org/2000/svg'
                      viewBox='0 0 2000 2000'>
                      <title>Gave Ink</title>
                      <path d='M1285.91,1054.23a285.13,285.13,0,0,1-90.46,208.66c-109.23,102.48-281.67,102.48-390.9,0a285.89,285.89,0,0,1-6.71-410.83l184.5-184.49a25,25,0,0,1,35.32,0l184.5,184.49A285.07,285.07,0,0,1,1285.91,1054.23Z' />
                    </svg>
                  ) : (
                    <div>
                      {isInking != true ? (
                        <svg
                          onClick={event => onInk(event, poem)}
                          className={[
                            poem.format == 'format_align_center' &&
                              'format-center-ink',
                            poem.format == 'format_align_left' &&
                              'format-left-ink',
                            poem.format == 'format_align_right' &&
                              'format-right-ink',
                            'ink-hover'
                          ]
                            .filter(e => e)
                            .join(' ')}
                          id='Layer_1'
                          data-name='Layer 1'
                          xmlns='http://www.w3.org/2000/svg'
                          viewBox='0 0 2000 2000'>
                          <title>Give Ink</title>
                          <path d='M1285.91,1054.23a285.13,285.13,0,0,1-90.46,208.66c-109.23,102.48-281.67,102.48-390.9,0a285.89,285.89,0,0,1-6.71-410.83l184.5-184.49a25,25,0,0,1,35.32,0l184.5,184.49A285.07,285.07,0,0,1,1285.91,1054.23Z' />
                        </svg>
                      ) : (
                        <svg
                          className={[
                            poem.format == 'format_align_center' &&
                              'format-center-ink',
                            poem.format == 'format_align_left' &&
                              'format-left-ink',
                            poem.format == 'format_align_right' &&
                              'format-right-ink',
                            'ink-hover'
                          ]
                            .filter(e => e)
                            .join(' ')}
                          id='Layer_1'
                          data-name='Layer 1'
                          xmlns='http://www.w3.org/2000/svg'
                          viewBox='0 0 2000 2000'>
                          <title>Giving Ink</title>
                          <path d='M1285.91,1054.23a285.13,285.13,0,0,1-90.46,208.66c-109.23,102.48-281.67,102.48-390.9,0a285.89,285.89,0,0,1-6.71-410.83l184.5-184.49a25,25,0,0,1,35.32,0l184.5,184.49A285.07,285.07,0,0,1,1285.91,1054.23Z' />
                        </svg>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <svg
                    className={[
                      poem.format == 'format_align_center' &&
                        'format-center-ink',
                      poem.format == 'format_align_left' && 'format-left-ink',
                      poem.format == 'format_align_right' && 'format-right-ink'
                    ]
                      .filter(e => e)
                      .join(' ')}
                    id='Layer_1'
                    data-name='Layer 1'
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 2000 2000'>
                    <title>Ink</title>
                    <path d='M1285.91,1054.23a285.13,285.13,0,0,1-90.46,208.66c-109.23,102.48-281.67,102.48-390.9,0a285.89,285.89,0,0,1-6.71-410.83l184.5-184.49a25,25,0,0,1,35.32,0l184.5,184.49A285.07,285.07,0,0,1,1285.91,1054.23Z' />
                  </svg>
                </div>
              )}
            </div>
            {poem.isClassic && (
              <div style={{ marginTop: '20px', marginBottom: '-10px' }}>
                <div className='chip'>Classic</div>
              </div>
            )}
            <p style={{ visibility: 'hidden', marginBottom: '25px' }}></p>
          </div>
        </li>
      ))}
    {limit >= totalPoems && loadingMore == false && <TheEnd />}
    {poems && totalPoems > limit && loadingMore == false && (
      <li className='collection-item'>
        <center>
          <a href='#!' className='load-more' onClick={loadMorePoems}>
            Load More
          </a>
        </center>
      </li>
    )}
    {poems && totalPoems + 5 > limit && loadingMore == true && (
      <li className='collection-item'>
        <center>
          <a href='#!' className='loading-more'>
            Loading more...
          </a>
        </center>
      </li>
    )}
  </ul>
);

export default compose(withFirebase)(Landing);
